export const VIEWER_READ_ONLY_CODE = 'viewer_read_only';

export const VIEWER_READ_ONLY_TITLE = 'View-only access';

export const VIEWER_READ_ONLY_FALLBACK =
  'Viewers can read this workspace but cannot create content or spend credits.';

function rawText(error: unknown): string {
  if (error instanceof Error) {
    const body = (error as { responseBody?: unknown }).responseBody;
    return `${error.message} ${typeof body === 'string' ? body : ''}`;
  }
  return typeof error === 'string' ? error : '';
}

export function viewerReadOnlyMessage(error: unknown): string | null {
  const raw = rawText(error);
  if (!raw.includes(VIEWER_READ_ONLY_CODE)) return null;
  for (const candidate of raw.split(/\s(?=\{)/)) {
    try {
      const parsed = JSON.parse(candidate.trim()) as { code?: unknown; error?: unknown };
      if (parsed.code === VIEWER_READ_ONLY_CODE && typeof parsed.error === 'string') {
        return parsed.error;
      }
    } catch {
      continue;
    }
  }
  return VIEWER_READ_ONLY_FALLBACK;
}
